import { IBannersCollection } from "../models/banner.model";

export function getCollectionByPlaceId(
    collections: IBannersCollection[],
    placeId: string
): IBannersCollection | undefined {
    return collections.find(collection => collection.placeId === placeId);
}